import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useIoContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { validateBundles, validateDayOfMonth, validateDiscountPeriodExpiration, validateIntegratedClass, validateLimitedTimeDiscountOffer, validateMaxCharges, validateOneTimeInStages, validatePreapprovedAmount, validatePriceIncrease, validateStartBillingAt, validateBillingInitiation } from '../logic';
export const useValidateService = ()=>{
    const { getNow } = useIoContext();
    const { START_BILLING_AT, START_BILLING_AT_PHASE_2_INLINE, YEARLY_AUTOMATIC_SERVICE, BILLING_OCCURRENCE_INLINE_SELECT_SERVICE_INSTANCE } = useFeatureFlags();
    const validate = (service, opts)=>{
        return [
            ...validateMaxCharges(service),
            ...opts.excludeBillingValidation ? [] : validateDayOfMonth(service),
            ...validatePriceIncrease(service, opts),
            ...validateIntegratedClass(service),
            ...validateLimitedTimeDiscountOffer(service, opts.now),
            ...validateOneTimeInStages(service),
            ...validateDiscountPeriodExpiration(service, opts.now, opts.relationshipEffectiveDate),
            ...validatePreapprovedAmount(service),
            ...validateBundles(service),
            ...START_BILLING_AT || START_BILLING_AT_PHASE_2_INLINE ? validateStartBillingAt(service, opts) : [],
            ...BILLING_OCCURRENCE_INLINE_SELECT_SERVICE_INSTANCE && !opts.excludeBillingValidation ? validateBillingInitiation(service, YEARLY_AUTOMATIC_SERVICE) : []
        ];
    };
    return {
        isInvalid: (service, opts)=>{
            const errors = validate(service, _object_spread_props(_object_spread({}, opts), {
                now: getNow()
            }));
            return errors.length > 0;
        }
    };
};
